import { z } from "zod";

export const addAgentNoteSchema = z
  .object({
    note: z
      .string()
      .trim()
      .min(1, { message: "Note cannot be empty" })
      .max(1000, { message: "Note cannot exceed 1000 characters" }),
    type: z.string().min(1, { message: "Type is required" }),
    reviewed: z.string().min(1, { message: "Reviewed status is required" }),
    reviewOn: z.date().nullable().optional(),
  })
  .refine(
    (data) => {
      if (data.reviewed === "false") {
        return data.reviewOn !== null && data.reviewOn !== undefined;
      }
      return true;
    },
    {
      message: "Review date is required when review is set to Yes",
      path: ["reviewOn"],
    }
  );

export type AddAgentNoteFormType = z.infer<typeof addAgentNoteSchema>;

export default addAgentNoteSchema;
